import React, { useState, useContext } from 'react';
import { sendSelectNewPaymentMethodEvent } from 'snowplow';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import AdyenCardForm from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/Payment/Ui/AdyenCardForm';
import CreditCardForm from 'ggApp/shared/common/Payment/PaymentGatewayList/CreditCard/NewFlow/Form';
import RedirectForm from 'ggApp/shared/common/Payment/PaymentGatewayList/RedirectForm';

import CreditCardFormUi from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/Payment/Ui/CreditCardForm';
import RedirectFormUi from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/Payment/Ui/RedirectForm';

import gatewayTypes from 'ggApp/modules/newCheckout/constants/gatewayTypes';

import { CardHeader, SepaHeader, PayPalHeader } from '../../MethodHeaders';
import { Wrap, PaymentMethod } from './styles';

const getGatewayComponents = (gateway, withNewFlowCard) => {
    switch (gateway.type) {
        case gatewayTypes.GATEWAY_TYPE_BANK_CARD:
            return {
                type: gatewayTypes.GATEWAY_TYPE_BANK_CARD,
                topContent: CardHeader,
                form: withNewFlowCard ? CreditCardForm : AdyenCardForm,
                uiComponent: CreditCardFormUi,
            };
        case gatewayTypes.GATEWAY_TYPE_SEPA:
            return {
                type: gatewayTypes.GATEWAY_TYPE_SEPA,
                topContent: SepaHeader,
                form: RedirectForm,
                uiComponent: RedirectFormUi,
            };
        case gatewayTypes.GATEWAY_TYPE_PAYPAL:
            return {
                type: gatewayTypes.GATEWAY_TYPE_PAYPAL,
                topContent: PayPalHeader,
                form: RedirectForm,
                uiComponent: RedirectFormUi,
            };
        default:
            return null;
    }
};

const GatewaySelectorUi = ({
    paymentGateways,
    onPaymentMethodCreated,
    onLegacyPaymentMethodCreated,
    orderNumber,
    withNewFlowCard,
    paymentTermsInfo,
    setPaymentTermsInfo,
    threeDSWarningFlag,
}) => {
    const [activeIndex, setActiveIndex] = useState();

    const { user, activeStore } = useContext(OrderContext);

    const handleCardClick = (index, gateway) => {
        sendSelectNewPaymentMethodEvent({
            eventLabel: gateway.toLowerCase() === 'paypal' ? 'paypal' : 'credit card',
            eventProperty: {
                store: activeStore.code,
                orderID: orderNumber,
                userID: user.id,
                '3dsWarning': threeDSWarningFlag,
                paymentMethod: gateway.toLowerCase() === 'paypal' ? 'paypal' : 'credit card',
            },
        });

        setActiveIndex(index);
    };

    return (
        <Wrap>
            {paymentGateways &&
                paymentGateways.map((gateway, index) => {
                    const { type, topContent, form, uiComponent } = getGatewayComponents(
                        gateway,
                        withNewFlowCard,
                    );
                    return (
                        <PaymentMethod
                            isNewPaymentOption
                            key={type}
                            topContent={topContent}
                            form={form}
                            uiComponent={uiComponent}
                            isActive={activeIndex === index}
                            handleClick={() => handleCardClick(index, gateway.type)}
                            onPaymentMethodCreated={onPaymentMethodCreated}
                            onLegacyPaymentMethodCreated={onLegacyPaymentMethodCreated}
                            orderNumber={orderNumber}
                            gateway={gateway}
                            paymentTermsInfo={paymentTermsInfo}
                            setPaymentTermsInfo={setPaymentTermsInfo}
                        />
                    );
                })}
        </Wrap>
    );
};

export default GatewaySelectorUi;
